import scrollLock from '../../functions/_scrollLock.js' // スクロールロック
const spMenuTrigger = document.querySelectorAll('#nav-open,#nav-close,#nav a,#overlay')
const spMenuTarget = document.querySelectorAll('#nav-open,#nav-close,#nav,#overlay')

const spNav = document.getElementById('nav')
if (spNav) {
  // SPナビのdisplay:noneを取り除く
  document.getElementById('nav').style.display = ''

  for (const trigger of spMenuTrigger) {
    trigger.addEventListener(
      'click',
      function () {
        // 押した箇所の.activeの有無やタグ種別を見て分岐
        if (!trigger.classList.contains('active') && trigger.tagName !== 'A') {
          for (const target of spMenuTarget) {
            target.classList.add('active')
          }
        } else {
          for (const target of spMenuTarget) {
            target.classList.remove('active')
          }
        }
        scrollLock('body', '.nav')
      },
      false
    )
  }
}
